export default __webpack_public_path__ + "73f427fe8b87b4a39626793727925dee.png";